import { Injectable } from '@angular/core';
import streamingData from '../../assets/jsondata/streaming-data.json';
@Injectable({
  providedIn: 'root'
})
export class StreamingService {
  streamData: any = streamingData.data;
  //services: any = serviceData.data.services;

  getJourneyStreamData() {
    return this.streamData;
  }
}